<div :class="mode">
  <div :class="className" class="flash-app row txt-center">
    <div class="col-12">
      <div :style="sizes" class="loader"></div>
      <div
        class="pl10 letter-spacing mt10"
        style="display: flex; align-items: center; justify-content: center"
      >
        {{ lang === "en" ? "Processing" : "កំពុងដំណើរការ" }}
        <div class="loading-dot" style="color: var(--black-light);">&#8226;&#8226;&#8226;</div>
      </div>
    </div>
  </div>
</div>
